import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LocationComparison = ({ locations }) => {
  const [selectedLocations, setSelectedLocations] = useState([locations[0], locations[1]]);
  const [showAll, setShowAll] = useState(false);

  const handleLocationSelect = (location, index) => {
    const newSelected = [...selectedLocations];
    newSelected[index] = location;
    setSelectedLocations(newSelected);
  };

  const metrics = [
    { key: 'talentPool', label: 'Talent Pool', unit: 'K+' },
    { key: 'avgSalary', label: 'Avg Salary', prefix: '₹', unit: 'L' },
    { key: 'infrastructure', label: 'Infrastructure Score', unit: '/10' },
    { key: 'costIndex', label: 'Cost Index', unit: '' },
    { key: 'timeZone', label: 'Time Zone', unit: '' }
  ];

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-headline font-semibold text-xl text-text-primary">Location Comparison</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setShowAll(!showAll)}
          iconName={showAll ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          {showAll ? 'Show Less' : 'Show All Metrics'}
        </Button>
      </div>

      {/* Location Selectors */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {selectedLocations.map((selected, index) => (
          <div key={index} className="relative">
            <label className="block text-sm font-medium text-text-primary mb-2">
              Location {index + 1}
            </label>
            <select
              value={selected.city}
              onChange={(e) => {
                const location = locations.find(loc => loc.city === e.target.value);
                handleLocationSelect(location, index);
              }}
              className="w-full p-3 border border-border rounded-lg bg-background text-text-primary focus:ring-2 focus:ring-cta focus:border-cta"
            >
              {locations.map((location) => (
                <option key={location.city} value={location.city}>
                  {location.city}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>

      {/* Comparison Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 font-medium text-text-primary">Metric</th>
              {selectedLocations.map((location, index) => (
                <th key={index} className="text-center py-3 px-4 font-medium text-text-primary">
                  {location.city}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {metrics.slice(0, showAll ? metrics.length : 3).map((metric) => (
              <tr key={metric.key} className="border-b border-border hover:bg-muted/30">
                <td className="py-3 px-4 font-medium text-text-primary">{metric.label}</td>
                {selectedLocations.map((location, index) => (
                  <td key={index} className="text-center py-3 px-4">
                    <span className="text-text-primary font-medium">
                      {metric.prefix || ''}{location[metric.key]}{metric.unit}
                    </span>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Quick Insights */}
      <div className="mt-6 p-4 bg-muted/30 rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Lightbulb" size={20} color="var(--color-accent)" />
          <div>
            <h4 className="font-medium text-text-primary mb-1">Quick Insight</h4>
            <p className="text-sm text-text-secondary">
              {`${selectedLocations[0].city} offers ${selectedLocations[0].talentPool > selectedLocations[1].talentPool ? 'larger talent pool' : 'cost advantages'} while ${selectedLocations[1].city} provides ${selectedLocations[1].talentPool > selectedLocations[0].talentPool ? 'larger talent pool' : 'cost advantages'}.`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationComparison;